import { Observable } from 'rxjs';
import { ajax, AjaxResponse } from 'rxjs/ajax';
import { ValidationPayload } from '../../../../reducers';
import Constants from '../../../../../env/constants';

export type FetchValidation = (payload: ValidationPayload) => Observable<AjaxResponse<ValidationResponse>>;
export const fetchValidation: FetchValidation = (payload) => {
    return ajax({
        url: `${Constants.serverBaseUrl}/v2/link/standalone`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: payload,
    });
};
